// Toogle menu mobile
var headers = document.querySelectorAll('.sliderow');

for(var i = 0; i < headers.length; i++) {
	headers[i].addEventListener('click', openCurrAccordion);
}

function openCurrAccordion(e) {
	for(var i = 0; i < headers.length; i++) {
		var parent = headers[i].parentElement;

		if (this === headers[i] && !parent.classList.contains('open')) {
			parent.classList.add('open');
		}
		else {
			parent.classList.remove('open');
		}
	}
}

// custom klarna message

const klarna = document.querySelector('klarna-placement');

	if (klarna) {

		const observer = new MutationObserver(function (mutations_list) {
			
				setTimeout(() => {
					const container = document.querySelector("klarna-placement > div")
					const shadowRoot = container.shadowRoot;
					
					const containerKlarna = shadowRoot.querySelector(".container");
					const icon = containerKlarna.querySelector("svg");
					const text = containerKlarna.querySelector(".text-wrapper");
					
					containerKlarna.style.fontSize = "16px";
					containerKlarna.style.padding = "0";
					containerKlarna.style.border = "0";
					containerKlarna.style.color = "#7a8387"
					containerKlarna.style.flexDirection = "row-reverse";
					containerKlarna.style.justifyContent = "flex-end";
					// icon.style.width = "33px";
					// icon.style.height = "20px";
					// icon.style.marginLeft = "5px";
					// text.style.marginLeft = "0";
					
					//   disconnect observer
					// observer.disconnect();
				}, 100);
	
		
		});
		var config = {
			attributes: true,
			childList: true,
			subTree: true
		};
		observer.observe(document.querySelector("klarna-placement"), config);
	}

// trigger click search mobile
if (document.querySelector(".search-btn-mobile") && document.querySelector('[data-popdown-toggle]')) {
	document.querySelector(".search-btn-mobile").addEventListener('click', (e)=> {
		e.preventDefault();
		document.querySelector('[data-popdown-toggle]').click();
	})
}
